import ChipCore from '@mui/material/Chip';
import React from 'react';
import tw, { css } from 'twin.macro';

//.MuiChip-deleteIcon {
//	display: none;
//}
//:hover {
//  .MuiChip-deleteIcon {
//    display: block;
//  }
//}

// const animationColour = keyframes`
// 	0% {
//     background: var(--color-grey-E);
// 		color: var(--color-dark);
//   }
//   40% {
//     color: var(--color-dark);
//   }
//   100% {
//     background: var(--color-green-4);
//     color: var(--color-light);
//   }
// `;

const cssChip = css`
	${tw`rounded-12 bg-grey-E text-dark px-04 py-12`};
	cursor: pointer;
	
  :hover {
    ${tw`rounded-12 bg-green-4 text-light px-04 py-12`};
  }
`;

export default function Chip({ onDelete, ...props }) {
	return (
		<ChipCore
			css={[ cssChip ]}
			onDelete={onDelete}
			{...props}
		/>
	);
}

Chip.defaultProps = {
	label: ''
};
